import * as React from 'react';
import { Link, navigate } from 'gatsby';

const HEADER_OFFSET = 24;

export function scrollToHash(hash, behavior = 'smooth') {
  if (!hash) return;
  const el = document.getElementById(hash.replace(/^#/, ''));
  if (!el) return;
  const sticky = document.querySelector('[data-r="topbar"]');
  const stickyHeight = sticky && getComputedStyle(sticky).display !== 'none' ? sticky.offsetHeight : 0;
  const top = el.getBoundingClientRect().top + window.scrollY - stickyHeight - HEADER_OFFSET;
  window.scrollTo({ top, behavior });
}

/**
 * A link to a section of another page. Gatsby's Link handles the route change
 * but not the hash, so same-page jumps scroll directly and cross-page jumps
 * navigate first, then scroll once the target page has rendered.
 */
export default function AnchorLink({ to, children, ...rest }) {
  const [path, hash] = to.split('#');

  const onClick = (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    const samePage = window.location.pathname.replace(/\/$/, '') === path.replace(/\/$/, '');
    if (samePage) {
      scrollToHash(hash);
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', `#${hash}`);
    } else {
      navigate(to);
    }
  };

  return (
    <Link to={to} onClick={onClick} {...rest}>
      {children}
    </Link>
  );
}
